// src/config/admin.js
export const ADMIN_PASSWORD = "SuperSecret123"; // change later
